<!-- HTML Start -->

<!-- Header Start -->
<header class="header-hld header-invison">


    <!-- Header Bottom Start -->
    <section class="header-bot b5containeradjust">
      <div class="container">
        <div class="row">
          <div class="col-9">
            <a href="javascript:void(0)" title="Sanlam" class="logo-hld" [routerLink]="userData!=null?['/portal/home']:['/register']">
                <app-logo size="large" [width]="203" [height]="44" [viewBox]="'0 0 203 44'"></app-logo>
            </a>
          </div>
          <div class="col-3 text-end d-flex justify-content-end">
            <button name="Header-Login" title="SanlamLogin" (click)="azureAdlogin()" class="loginlink" *ngIf="userData==null">
              <span class="d-md-block d-none">Login</span>
              <span class="d-md-none d-block">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 4C12 6.21 10.21 8 8 8C5.79 8 4 6.21 4 4C4 1.79 5.79 0 8 0C10.21 0 12 1.79 12 4ZM0 14C0 11.34 5.33 10 8 10C10.67 10 16 11.34 16 14V16H0V14Z" fill="#8A929C"/>
                  </svg>
              </span>
            </button>


          </div>
        </div>
      </div>
    </section>
    <!-- Header Bottom Start -->

  </header>
